import { ChangeDetectionStrategy, Component } from '@angular/core';

import { AuthService } from '@auth/services';
import { FacilityService } from '@facility/services';

@Component({
  selector: 'z-user-facility',
  templateUrl: './user-facility.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserFacilityComponent {
  constructor(public authService: AuthService, public facilityService: FacilityService) {}
}
